import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, DashboardReducer, DashboardState } from './dashboard-reducer';


const DashboardContext = createContext<DashboardState | undefined>(undefined);
const DashboardContextDispatchContext = createContext({} as any);

const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(DashboardReducer, {  } as DashboardState);

    return (
        <DashboardContext.Provider value={state}>
            <DashboardContextDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardContextDispatchContext.Provider>
        </DashboardContext.Provider>
    );
}

const useDashboardState = () => {
    const context = useContext(DashboardContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useDashboardDispatch = () => {
    const context = useContext(DashboardContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { DashboardProvider, useDashboardDispatch, useDashboardState, ACTION_TYPES };
